import { OrderStatus, OrderStatusColor } from "../../../domain/Orders/OrderStatus";
import { BadgeDomain } from "../../Abstractions/BadgeDomain";

export function OrderStatusBadge({ status, className, size, ...props }) {
  const value = OrderStatus[status];
  const color = OrderStatusColor[status];

  return <BadgeDomain className={className} bg={color} size={size} {...props}>{value}</BadgeDomain>;
}